// Import Css Here 
import './assets/scss/style.scss';
import React, { useState, useEffect } from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import PageScrollTop from './components/pageToTop/PageScrollTop'
import BusinessConsulting2 from "./pages/BusinessConsulting2";
import Contact from "./elements/contact/Contact";







const App = () => {
    
    return (
        <Router>
            <PageScrollTop>
                <Switch>
                   
                    <Route path={`${process.env.PUBLIC_URL + "/"}`}exact component={BusinessConsulting2}/>
                    <Route path={`${process.env.PUBLIC_URL + "/contacto"}`} exact component={Contact}/>

                </Switch>
            </PageScrollTop>
        </Router>
    )
}


export default App




